import React from "react";

interface Props {
  className?: string;
}

const StakingLink = ({ className = "" }: Props) => (
  <a
    href="https://stake.dotone.online/"
    target="_blank"
    rel="noopener noreferrer"
    className={`blob-btn ${className}`}
  >
    Staking
    <span className="blob-btn__inner">
      <span className="blob-btn__blobs">
        <span className="blob-btn__blob" />
        <span className="blob-btn__blob" />
        <span className="blob-btn__blob" />
        <span className="blob-btn__blob" />
      </span>
    </span>
  </a>
);

export default StakingLink;
